import axios from 'axios'
// create an axios instance
import {
	Message
} from 'element-ui'
import router from '@/router'
// const baseURL = 'http://192.168.0.59:8884/qg-center' //本地
const baseURL = 'https://kzrt-api.18yimu.com/qg-api' //线上
const service = axios.create({
	// withCredentials: true, // send cookies when cross-domain requests
	baseURL,
	timeout: 0, // request timeout
})

let showError = false

// request interceptor
service.interceptors.request.use(
	(config) => {
		config.headers['Content-Type'] = 'application/json; charset=UTF-8'
		let token = localStorage.getItem("accessToken");
		if (token) {
			config.headers["token"] = token;
		}
		return config
	},
	(error) => {
		console.log(error)
		return Promise.reject(error)
	}
)

// response interceptor
service.interceptors.response.use(
	(response) => {
		if (response.data.code == 0 || response.data.code == 200) {
			return response.data
		} else if (response.data.code == 401) {
			if (!showError) {
				showError = true
				Message({
					message: response.data.msg,
					type: "warning",
				});
				setTimeout(() => {
					showError = false
				}, 2000);
			}
			router.replace('/login')
		} else {
			Message({
				message: response.data.msg,
				type: "warning",
			});
		}

	},
	(error) => {
		console.log(error)

		return Promise.reject(error)
	}
)
export default service